import { render } from "./Knowledge.vue?vue&type=template&id=1e167dd8&scoped=true"
import script from "./Knowledge.vue?vue&type=script&lang=js"
export * from "./Knowledge.vue?vue&type=script&lang=js"

import "./Knowledge.vue?vue&type=style&index=0&id=1e167dd8&scoped=true&lang=css"

import exportComponent from "D:\\my\\game-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e167dd8"]])

export default __exports__